import { render, staticRenderFns } from "./BasicsEnergyPriceAnalysis.vue?vue&type=template&id=64a4ce51&scoped=true"
import script from "./BasicsEnergyPriceAnalysis.vue?vue&type=script&lang=js"
export * from "./BasicsEnergyPriceAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BasicsEnergyPriceAnalysis.vue?vue&type=style&index=0&id=64a4ce51&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4ce51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a4ce51')) {
      api.createRecord('64a4ce51', component.options)
    } else {
      api.reload('64a4ce51', component.options)
    }
    module.hot.accept("./BasicsEnergyPriceAnalysis.vue?vue&type=template&id=64a4ce51&scoped=true", function () {
      api.rerender('64a4ce51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPriceAnalysis/BasicsEnergyPriceAnalysis.vue"
export default component.exports